<template>
  <div>
    <el-card class="box-card">
       <div slot="header" class="clearfix">
        <span><i class="el-icon-money"></i> Card</span>
       </div>

      <data-tables v-loading="loading" :data="dataTable" border :page-size="10" :pagination-props="{ background: true, pageSizes: [5, 10, 20, 50, 100] }">

        <el-table-column prop="currency" label="Currency" header-align="center" align="center" fixed width="80"></el-table-column>
        <el-table-column prop="card_id" label="Card ID" header-align="center" align="center" width="250"></el-table-column>
        <el-table-column prop="card_token" label="Card Token" header-align="center" align="center" width="180"></el-table-column>
        <el-table-column prop="last4digit" label="Last 4 Digit" header-align="center" align="center" width="120"></el-table-column>
        <el-table-column prop="bankholderID" label="BankholderID" header-align="center" align="center" width="200"></el-table-column>
        <el-table-column prop="expire_date" label="Expire date" header-align="center" align="center" width="150"></el-table-column>
        <el-table-column prop="card_status" label="Status" header-align="center" align="center" width="120"></el-table-column>
        <el-table-column prop="card_type" label="Type" header-align="center" align="center" width="100"></el-table-column>
        <el-table-column prop="replace_by" label="Replace By" header-align="center" align="center" width="150"></el-table-column>
        <el-table-column prop="remark" label="Remark" header-align="center" align="center" width="150"></el-table-column>
        <el-table-column prop="card_id" label="Action" header-align="center" align="left" fixed="right" width="330">
          <template slot-scope="scope">
            <span v-if="!['closed', 'replaced', 'lost'].includes(scope.row.card_status)">
              <el-button v-if="scope.row.card_status === 'issued'" size="mini" type="primary" @click="activateCard(scope.row.card_id)">Activate</el-button>
              <el-button v-if="scope.row.card_status === 'active'" size="mini" type="primary" @click="replaceCard(scope.row.card_id)">Replace</el-button>
              <el-button v-if="scope.row.card_status === 'blocked'" size="mini" type="primary" @click="updateStatus(scope.row.card_status, 'active', scope.row.card_id)">Active</el-button>
              <el-button v-if="scope.row.card_status === 'active'" size="mini" type="info" @click="updateStatus(scope.row.card_status, 'blocked', scope.row.card_id)">Block</el-button>
              <el-button v-if="scope.row.card_status != 'issued'" size="mini" type="success" @click="getPin(scope.row.card_id)">Get PIN</el-button>
              <el-button v-if="scope.row.card_status != 'issued'" size="mini" type="warning" @click="resetPin(scope.row.card_id)">Reset PIN</el-button>
              <el-button v-if="scope.row.card_status != 'issued'" size="mini" type="danger" @click="updateStatus(scope.row.card_status, 'closed', scope.row.card_id)">Close</el-button>
            </span>
          </template>
        </el-table-column>

      </data-tables>

    </el-card>

    <CardStatus ref="CardStatus" v-on:submited="getCardList()"/>
    <CardGetPin ref="CardGetPin"/>
    <CardResetPin ref="CardResetPin"/>
    <CardIssue ref="CardIssue" v-on:submited="getCardList()"/>
    <CardActivate ref="CardActivate" v-on:submited="getCardList()"/>
    <CardReplace ref="CardReplace" v-on:submited="getCardList()"/>

  </div>
</template>

<script>
import { cardListBankholder } from "@/api/card";
import { findObject } from "@/utils";
import CardStatus from './card-status'
import CardGetPin from './card-getpin'
import CardResetPin from './card-resetpin'
import CardIssue from './card-issue'
import CardActivate from './card-activate'
import CardReplace from './card-replace'
export default {
  components:{
    CardStatus,
    CardGetPin,
    CardResetPin,
    CardIssue,
    CardActivate,
    CardReplace
  },
  props: {
    bankholderID: String,
  },
  data() {
    return {
      loading: false,
      dataTable: [],
    };
  },
  methods: {

    getCardList() {
      cardListBankholder(this.bankholderID).then(({ result, data }) => {
        if (result) {
          this.dataTable = data;
          let getActive = findObject(data, 'active', 'card_status');
          this.$emit('rendered', getActive)
        }
      });
    },

    activateCard(cardID){
      this.$refs.CardActivate.openDialog(cardID)
    },

    replaceCard(cardID){
      this.$refs.CardReplace.openDialog(cardID)
    },

    issueCard(){
      this.$refs.CardIssue.openDialog(this.customer, this.bankaccount)
    },

    getPin(cardID){
      this.$refs.CardGetPin.openDialog(cardID)
    },

    resetPin(cardID){
      this.$refs.CardResetPin.openDialog(cardID)
    },

    updateStatus(statusFrom, statusTo, cardID){
      this.$refs.CardStatus.openDialog(statusFrom, statusTo, cardID)
    }
  },
  created() {
    this.getCardList();
  },
};
</script>

<style>
</style>